import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import './assets/css/element-variables.scss'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);


import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


import App from './App.vue'
import axios from 'axios'
Vue.prototype.$axios = axios;

import plugins from './plugins' // plugins

import wow from 'wowjs'
import './assets/css/animate.css'
Vue.prototype.$wow = wow

import './assets/css/base.scss'


// 分页组件
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
// 富文本组件
import Editor from "@/components/Editor"
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// 字典标签组件
import DictTag from '@/components/DictTag'

// 字典数据组件
//import DictData from '@/components/DictData'
//wms table组件
import WmsTable from '@/components/WmsTable'

//NavMenu组件
import NavMenu from '@/components/NavMenu'

import DictRadio from '@/components/DictRadio'
import DictSelect from '@/components/DictSelect'

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImgView from './components/ImgView.vue'

Vue.use({
    install(vue) {
        const Constructor = vue.extend(ImgView)
        vue.prototype.$imgView = urlList => {
            const instance = new Constructor({
                data() {
                    return {
                        visible: true,
                        urlList: urlList
                    }
                }
            })
            const instanceDom = instance.$mount()
            document.body.appendChild(instanceDom.$el)
        }
    }
})

// 全局组件挂载
Vue.component('DictTag', DictTag)
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Editor', Editor)
Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
Vue.component('WmsTable', WmsTable)
Vue.component('DictRadio', DictRadio)
Vue.component('DictSelect', DictSelect)
Vue.component('Treeselect', Treeselect)
Vue.component('NavMenu', NavMenu)

Vue.use(plugins)

import i18n from './i18n/'
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value) //重点！！在注册Element时设置i18n的处理方法（这里有个小坑）
});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')